import { shallowEqual, useSelector } from 'react-redux';

const useShallowEqualSelector = <T>(selector: (state: IAppState) => T) =>
  useSelector(selector, shallowEqual);

export default useShallowEqualSelector;
